import { FullPageLoad, useAxios } from "common";
import { useParams } from "react-router-dom";
import SourcingRequestForm from "../SourcingRequestForm";
import validationSchema from "../validationSchema";

const EditSourcingRequest = () => {
  const { sourcingRequestId } = useParams();
  const { response, refetch } = useAxios({
    callOnLoad: {
      method: "GET",
      url: `/sourcingRequests/${sourcingRequestId}`,
      params: {
        populate: JSON.stringify(["brandRequest", "requestedBy"]),
      },
    },
  });

  if (!response) return <FullPageLoad fillWidth />;

  const formikSchema = {
    initialValues: response.data,
    validationSchema,
  };

  return (
    <SourcingRequestForm formikSchema={formikSchema} isEdit refetch={refetch} />
  );
};

export default EditSourcingRequest;
